require('./dist/progress-spinner/ds6/progress-spinner.css');
